var React = require('react');

function Card (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"288","height":"199","fill":"white","key":0}),React.createElement("rect",{"width":"288","height":"199","fill":"#F2F2F2","key":1}),React.createElement("rect",{"x":"40","y":"28","width":"208","height":"143","rx":"12","fill":"white","key":2}),React.createElement("rect",{"x":"64","y":"52","width":"160","height":"32","fill":"#D8D8D8","key":3}),React.createElement("rect",{"x":"64","y":"100","width":"160","height":"47","fill":"#D8D8D8","key":4})]);
}

Card.defaultProps = {"width":"288","height":"199","viewBox":"0 0 288 199","fill":"none"};

module.exports = Card;

Card.default = Card;
